import validation from 'validate.js'

export default function validate (data, fieldName, constraints) {
  if (!constraints) {
    return null
  }

  const formFields = {}

  if (!Object.prototype.hasOwnProperty.call(data, fieldName)) {
    data[fieldName] = null
  }

  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key) && !Object.prototype.hasOwnProperty.call(formFields, key)) {
      formFields[key] = constraints[key]
    }
  }

  const result = validation(data, formFields)

  if (result && result[fieldName] && result[fieldName].length > 0) {
    return result[fieldName][0]
  }
  return null
}